export default __webpack_public_path__ + "static/media/ui_logo_cast_1.858379ab.svg";